<template>
  <div class="curriculum">
    <ComponentEmpty
      v-if="list.length == 0"
      title="暂无我的课程"
      tips=""
    />
    <div v-else>
      <!-- <h2><span></span>我的课程</h2> -->
      <div class="curriculum-tab">
        <div class="curriculum-tab_title">
          <p>学年</p>
          <p>学期</p>
          <p>课程名称</p>
          <p>授课老师</p>
          <p>联系电话</p>
          <p>考试方式</p>
        </div>
        <div class="curriculum-tab_list">
          <div class="curriculum-tab_list__item" v-for="(item,index) in list" :key="index">
            <div class="year">{{item.start_year}}</div>
            <div class="semester">
              <div class="semester-list" v-for="(itemToo,indexToo) in item.son" :key="indexToo">
                <div>{{itemToo.start_semester == 1 ? '上半学期' : '下半学期'}}</div>
                <ul>
                  <li v-for="(itemThree,indexThree) in itemToo.son" :key="indexThree">
                    <span>{{itemThree.course_title}}</span>
                    <span>{{itemThree.teacher_title}}</span>
                    <span>{{itemThree.teacher_mobile}}</span>
                    <span>{{itemThree.exam_type | examTypeFilter}}</span>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getAllCourseApi } from "@/api/basic";
// import { filter } from 'vue/types/umd';
export default {
  // name: "Curriculum",
  name: 'courseList',
  components: {
  },
  filters: {
    examTypeFilter(v){
      const obj = {
        1: '统考',
        2: '考查',
        3: '毕业设计',
      };
      return obj[v];
    },
  },
  data() {
    return {
      list:[],
      listTotal:-1,
    };
  },
  computed: {
    ...mapState('permission', [
      '_ENTRANCETYPE',
    ])
  },
  methods: {
    async getListFn(){
      const {code,result,msg} = await getAllCourseApi();
      if(code != 200)return
      this.list = result
      this.listTotal = result.length
    },
  },
  created() {
    this.getListFn()
  },
  beforeDestroy() {

  },
};
</script>

<style lang="scss" scoped>
.curriculum {
  min-height:$sideBarH;
  margin: 20px;
  padding: 20px;
  background: $white;
  h2{
    display: flex;
    align-items: center;
    span{
      width: 4px;
      height: 20px;
      background: $primary;
      margin-right: 10px;
    }
  }
  &-tab{
    margin-top: 20px;
    border: 1px solid #E2E2E2;
    border-bottom: 0;
    border-right: 0;
    &_title{
      display: flex;
      background: #F4F6F9;
      p{
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #E2E2E2;
        border-right: 1px solid #E2E2E2;
        flex: 1;
        &:nth-of-type(1){
          width: 130px;
          flex: none;
        }
        &:nth-of-type(2){
          width: 230px;
          flex: none;
        }
      }
    }
    &_list{
      &__item{
        display: flex;
        .year{
          width: 130px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-bottom: 1px solid #E2E2E2;
          border-right: 1px solid #E2E2E2;
        }
        .semester{
          flex: 1;
          &-list{
            flex: 1;
            display: flex;
            div{
              width: 230px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-bottom: 1px solid #E2E2E2;
              border-right: 1px solid #E2E2E2;
            }
            ul{
              flex: 1;
              li{
                display: flex;
                min-height: 50px;
                span{
                  flex: 1;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-bottom: 1px solid #E2E2E2;
                  border-right: 1px solid #E2E2E2;
                }
              }
            }
          }

        }
      }
    }
    &_no{
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #E2E2E2;
      border-right: 1px solid #E2E2E2;
    }
  }
}
</style>
